export default {
  messages(state) {
    return state.messages
  },
}
